import {
  saveSimInventoryColumnWidth,
  saveSimInventoryTableConfiguration,
} from 'simInventory/SimInventoryApi/simInventoryTableConfigurationApi';
import { simInventoryQueries } from 'src/simInventory/Inventory/queries/simInventoryQueries';
import { useColumnActions } from 'src/common/components/Sim/Inventory/hooks/useColumnActions';
import { TableConfiguration } from 'src/common/components/Sim/Inventory/constants/columnConfigurationsConstants';

export const useSimProfilesColumnActions = (configuration: TableConfiguration) => {
  return useColumnActions({
    configuration,
    saveColumnWidth: saveSimInventoryColumnWidth,
    saveConfiguration: saveSimInventoryTableConfiguration,
    queryKey: simInventoryQueries.lists(),
  });
};
